import { useQuery } from 'react-query';
import { getDiameters } from '../services/diameter-api.service';

export default function useDiameters() {
  return useQuery(['diameters'], () => getDiameters().then(({ data }) => data));
}
